import { Component, OnInit } from '@angular/core';
import { BreakdownService } from '../breakdown.service';
import {ActivatedRoute, Router, Navigation} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from '../../quote.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-breakdown-quote-view',
  templateUrl: './breakdown-quote-view.component.html',
  styleUrls: ['./breakdown-quote-view.component.css']
})
export class BreakdownQuoteViewComponent implements OnInit {
  private static readonly INPROGRESS_STATUS_ID = 'e216564f-552a-4e45-ae67-0a63b7074691';
  private static readonly QUOTED_STATUS_ID = '80c0db90-ba5d-4387-b09a-4c008a664932';
  private static readonly REFERRED_STATUS_ID = 'f6d14624-6351-4d93-b27b-70fb8a06ec5d';
  private static readonly DECLINED_STATUS_ID = 'dda8734c-d149-4336-b8cc-c2e205430752';
  private static readonly INSURED_STATUS_ID = '5c952313-48e7-4834-9890-b118635befea';
  private static readonly CANCELLED_STATUS_ID = '7a877243-0919-4f92-8c35-6f5732013ca6';
  private static readonly LOST_STATUS_ID = 'd6d1ebc1-f35f-425e-8dee-cec371136e64';

  authDetails = '';
  staticData;
  id = this.route.snapshot.params.quote_id;
  selectedIndex = 0;
  isAdmin = false;
  isStaff = false;
  isBroker = false;
  disablIfPastDate = false;
  statusLabel = '';
  statusBadgeClass = 'badge-secondary';

  quoteDetails: any = {};
  fullQuote;

  constructor(
    private breakdownService: BreakdownService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private quoteService: QuoteService,
    private sessionSt: LocalStorageService,
    private _snackBar: MatSnackBar
  ){}

  public ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_staff')) {
      this.isStaff = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.selectedIndex = 5;
    }

    this.getQuote();
  }

  // GET STATIC DATA
  public getStaticData(response) {
    this.breakdownService.getStaticData(this.authDetails)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        },
        (error) => {
        }
      );
  }

  // GET QUOTE DETAILS
  public getQuote() {
    this.breakdownService.getBreakdownQuoteDetailsByQuoteID(this.route.snapshot.params.quote_id)
      .subscribe(
        (response: any) => {
          this.quoteDetails = response.result.quote;
          this.quoteDetails.id = response.result.quote.id;
          this.quoteDetails.insurance_status_id = response.result.quote.insurance_status_id;
          this.quoteDetails.company_id = response.result.quote.company_id;
          this.quoteDetails.broker_name = response.result.quote.broker_name;
          this.quoteDetails.company_name = response.result.quote.policy_holder_detail.company_name;
          this.quoteDetails.is_send_email = response.result.quote.is_send_email;
          this.quoteDetails.type = response.result.quote.type;
          this.quoteDetails.broker_id = response.result.quote.broker_id;
          this.quoteDetails.notes = response.result.quote.notes;
          if (response.result.quote.financial_details) {
            this.quoteDetails.peliwica_fee = response.result.quote.financial_details.fees;
            this.quoteDetails.broker_commission = response.result.quote.financial_details.broker_commission;
            this.quoteDetails.broker_admin_fee = response.result.quote.financial_details.broker_admin_fee;
          } else {
            this.quoteDetails.peliwica_fee = 0;
            this.quoteDetails.broker_commission = 0;
            this.quoteDetails.broker_admin_fee = 0;
          }

          this.quoteDetails.email = response.result.quote.policy_holder_detail?.email;
          this.quoteDetails.phone = response.result.quote.policy_holder_detail?.phone;
          this.quoteDetails.is_email = response.result.quote.policy_holder_detail?.is_email;
          this.quoteDetails.is_phone = response.result.quote.policy_holder_detail?.is_phone;
          this.quoteDetails.sms = response.result.quote.policy_holder_detail?.sms;
          this.quoteDetails.post = response.result.quote.policy_holder_detail?.post;
          this.quoteDetails.affinity_partner = response.result.quote.affinity_partner;
          this.quoteDetails.transactional_date = response.result.quote.transactional_date;
          this.fullQuote = response.result.quote;
          this.quoteDetails.is_paid = response.result.quote.is_paid;
          this.quoteDetails.product_id = response.result.quote.product_id;
          this.quoteDetails.is_policy = response.result.quote.is_policy;
          this.quoteDetails.quote_meta_policy_status = response.result.quote.quote_meta_policy_status;

          this.updateQuoteState();
          this.getQuoteNotes();
        },
      );
  }

  private updateQuoteState(): void {
    const type = Number(this.quoteDetails?.type);
    if (type === 4) {
      this.statusLabel = 'Cancelled';
      this.statusBadgeClass = 'badge-dark';
      return;
    }
    const statusId = this.quoteDetails?.insurance_status_id;
    if (statusId === BreakdownQuoteViewComponent.REFERRED_STATUS_ID) {
      this.statusLabel = 'Referred';
      this.statusBadgeClass = 'badge-warning';
    } else if (statusId === BreakdownQuoteViewComponent.QUOTED_STATUS_ID) {
      this.statusLabel = 'Quoted';
      this.statusBadgeClass = 'badge-success';
    } else if (statusId === BreakdownQuoteViewComponent.DECLINED_STATUS_ID) {
      this.statusLabel = 'Declined';
      this.statusBadgeClass = 'badge-danger';
    } else if (statusId === BreakdownQuoteViewComponent.INSURED_STATUS_ID) {
      this.statusLabel = 'Insured';
      this.statusBadgeClass = 'badge-primary';
    } else if (statusId === BreakdownQuoteViewComponent.CANCELLED_STATUS_ID) {
      this.statusLabel = 'Cancelled';
      this.statusBadgeClass = 'badge-dark';
    } else if (statusId === BreakdownQuoteViewComponent.LOST_STATUS_ID) {
      this.statusLabel = 'Lost';
      this.statusBadgeClass = 'badge-secondary';
    } else if (statusId === BreakdownQuoteViewComponent.INPROGRESS_STATUS_ID) {
      this.statusLabel = 'In Progress';
      this.statusBadgeClass = 'badge-info';
    } else {
      this.statusLabel = 'In Progress';
      this.statusBadgeClass = 'badge-info';
    }
  }

  // Issue Quote
  issueQuotePopup(issueQuoteModal) {
    this.disablIfPastDate = false;

    const policyStartDate = new Date(this.quoteDetails.policy_start_date || this.quoteDetails.inception_date);
    policyStartDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (policyStartDate.getTime() < today.getTime()) {
      this.disablIfPastDate = true;
    }

    this.modalService.open(issueQuoteModal, { centered: true });
  }

  issueQuote() {
    const data = {
      "quote_id": this.route.snapshot.params.quote_id
    };

    this.breakdownService.issueQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.modalService.dismissAll();
            const id = this.route.snapshot.params.quote_id;
            this.router.navigateByUrl('/breakdown/policy/' + id);
          }
        });
  }

  /*
  * Get Notes
  */
  hasImportantNotes: boolean = false;
  totalImpNotes: number = 0;

  getQuoteNotes() {
    this.quoteService.getNotes(this.quoteDetails.id)
      .subscribe(
        (response: any) => {
          let impNotes = response.result.filter(x => x.is_important == 1);
          this.totalImpNotes = impNotes.length;
          if (impNotes.length > 0) {
            this.hasImportantNotes = true;
          }
        });
  }

  onhasImportantNotesChange(event) {
    this.hasImportantNotes = event;
    this.totalImpNotes = this.totalImpNotes + 1;
  }

  displayEmailView: boolean = false;
  displayNewEmailView: boolean = false;

  newEmailView() {
    this.displayNewEmailView = true;
  }

  email_id: string = '';

  getEmailView(email_id) {
    this.email_id = email_id;
    this.displayEmailView = true;
  }

  backToEmailsList() {
    this.displayEmailView = false;
    this.displayNewEmailView = false;
  }
}
